import { render, staticRenderFns } from "./RoutinesOverview.vue?vue&type=template&id=db8b7b20&"
import script from "./RoutinesOverview.vue?vue&type=script&lang=js&"
export * from "./RoutinesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports